export const environment = {
  "env":"dev",
  "ServerRootAddress":"https://web.tolomatic.com/YDH/"
};
